import TextFilter from './TextFilter.component';

export default TextFilter;
